import strFunc from "@/lib/lyg/string";

function TodoTestTd(props: any) {
  let myProps = {
    Style: {},
    info: {},
    is_check_show_textarea: false,
    is_checked_row: false,
    select_date: "",
    pre_date_str: "",
    sort: "study",//pre_homework
    subject_name: "",

    daily_info: {},
    open_todo_word_result_one_popup: (inData: any) => { },
    ...props
  };
  let Style = myProps.Style;
  let info = myProps.info;
  let test_score_num = 0;
  let test_score_title = "";
  let text_todo_info: any = null;
  if (info.td_sort_data_json && info.td_sort_data_json["pre_homework"]
    && info.td_sort_data_json["pre_homework"].todo_info_arr.length > 0
  ) {
    for (let t_i = 0; t_i < info.td_sort_data_json["pre_homework"].todo_info_arr.length; t_i++) {
      let todo_info = info.td_sort_data_json["pre_homework"].todo_info_arr[t_i];
      if ((todo_info.a_sort_det == "cg_word"||todo_info.a_sort_det == "cg_word_custom") && todo_info.a_subject == myProps.subject_name) {
        text_todo_info = todo_info;
        let total_cnt = strFunc.uncomma_int(todo_info.a_success_amount);
        let amount_cnt = strFunc.uncomma_int(todo_info.a_amount_num);
        let test_score_cnt = strFunc.uncomma_int(todo_info.a_test_score);
        if (total_cnt != 0 && test_score_cnt != 0) {
          test_score_num = Math.floor((test_score_cnt / total_cnt) * 100);
        }
        test_score_title = test_score_num + "점 (" + test_score_cnt + "/" + total_cnt + ")";
      }
    }
  }

  return (
    <div title={test_score_title} style={{ cursor: "pointer" }}
      onClick={() => {
        if (text_todo_info) {
          myProps.open_todo_word_result_one_popup({ todo_info: text_todo_info });
        }
      }}>
      {test_score_num > 0 &&
        <span style={{ color: "#666" }}>{test_score_num}점</span>
      }
    </div>
  );
};
export default TodoTestTd;